import { usePersonalDataPolicyStore } from '@app/shared/src/stores/personal-data-policy';
import { SafeEnv } from '@packages/toolbox';
import { boot } from 'quasar/wrappers';

function startYandexMetricWorking() {
  const yaCode = SafeEnv(() => process.env.YANDEX_METRIC_CODE);

  if (!yaCode) {
    return;
  }

  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    for (var j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) {
        return;
      }
    }
    (k = e.createElement(t)),
      (a = e.getElementsByTagName(t)[0]),
      (k.async = 1),
      (k.src = r),
      a.parentNode.insertBefore(k, a);
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

  /*
    Параметры настройки Яндекс Метрики
    https://yandex.ru/support/metrica/code/counter-initialize.html
  */
  ym(yaCode, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: SafeEnv(() => process.env.YANDEX_METRIC_WEBVISOR) === 'true',
  });
}

export default boot(({ store }) => {
  const personalDataPolicyStore = usePersonalDataPolicyStore(store);
  if (personalDataPolicyStore.cookiesWasAccepted) {
    startYandexMetricWorking();
  } else {
    personalDataPolicyStore.$subscribe((mutation, state) => {
      if (state.cookiesWasAccepted) {
        startYandexMetricWorking();
      }
    });
  }
});
